import { Textarea as HeadlessTextarea, Field, Label, Description } from "@headlessui/react";
import React, { forwardRef } from "preact/compat";
import classNames from "classnames";
import { Icon } from "@/elements-react/fix-icon";
import styles from "./Textarea.module.scss";

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  className?: string;
  label?: string;
  helpText?: string;
  customError?: string;
  clearable?: boolean;
  onClear?: () => void;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onInput?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  inputSize?: "small" | "medium" | "large";
  rows?: number;
  resize?: "none" | "vertical" | "horizontal" | "both";
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      name,
      label,
      helpText,
      customError,
      onChange,
      onInput,
      onClear,
      clearable = false,
      value,
      className,
      inputSize = "large",
      rows,
      resize = "none",
      ...props
    },
    ref,
  ) => {
    const showClear = clearable && value;
    const helpMessage = customError || helpText;

    return (
      <Field className={classNames(styles.field, className)}>
        {label && <Label className={styles.label}>{label}</Label>}

        <div className={classNames(styles.wrapper, styles[inputSize])}>
          <HeadlessTextarea
            ref={ref}
            name={name}
            value={value}
            invalid={!!customError}
            rows={rows}
            onChange={onChange}
            onInput={onInput}
            className={classNames(styles.input, styles[inputSize])}
            {...(props as any)}
            style={{ ...(props as any)?.style, resize }}
          />

          {showClear && !!customError && (
            <div className={classNames(styles.icon, styles.clearIcon)} onClick={onClear}>
              <Icon name="x-circle" width={20} />
            </div>
          )}
        </div>

        {helpMessage && (
          <Description
            className={classNames(styles.description, {
              [styles.error]: !!customError,
            })}
          >
            {helpMessage}
          </Description>
        )}
      </Field>
    );
  },
);
